import React, { useState } from 'react';
import { Card, Form, Button, Alert } from 'react-bootstrap';
import Header from '../components/Header';

export default function Login({ setPage }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = () => {
    if (email === 'user@gmail.com' && password === 'user@123') {
      localStorage.setItem('token', 'demo-token'); // you can store any token-like string
      setPage('dashboard');
    } else {
      setError('Invalid email or password');
    }
  };

  return (
    <Card className="mx-auto card-transparent" style={{ maxWidth: '400px' }}>
      <Card.Body>
        <Header />
        <Form>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form.Group className="mb-3">
            <Form.Control
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Control
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Form.Group>
          <Button className="w-100 mb-2" onClick={handleLogin}>
            Login
          </Button>
          <div className="text-center">
            demo credentials : user@gmail.com,user@123{' '}
            <Button variant="link" onClick={() => setPage('register')}>
              Register
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
}
